import { render, staticRenderFns } from "./InspectionViewCustomer.vue?vue&type=template&id=b16994a2"
import script from "./InspectionViewCustomer.vue?vue&type=script&lang=js"
export * from "./InspectionViewCustomer.vue?vue&type=script&lang=js"
import style0 from "./InspectionViewCustomer.vue?vue&type=style&index=0&id=b16994a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports